function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import propTypes from 'prop-types';
import { observer } from 'mobx-react';
import InfoIcon from "../Icon/Info";
import classNames from 'classnames';
import Tooltip from "../Tooltip";

class InfoBox extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderIcon", ({
      tooltip,
      icon
    }) => {
      if (!tooltip && !icon) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "info-box-wrapper__icon"
      }, this.props.tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
        tooltip: this.props.tooltip
      }, /*#__PURE__*/React.createElement("div", null, this.props.icon)) : this.props.icon);
    });
  }

  render() {
    const className = this.props.className;
    const classes = classNames({
      'info-box-wrapper': true,
      ['info-box-wrapper--' + this.props.theme]: true,
      [className]: className
    });
    return /*#__PURE__*/React.createElement("div", {
      className: classes
    }, this.renderIcon(this.props), /*#__PURE__*/React.createElement("div", {
      className: "info-box-wrapper__rows"
    }, this.props.children));
  }

}

InfoBox.propTypes = {
  theme: propTypes.oneOf(['blue', 'red', 'yellow']),
  icon: propTypes.element,
  className: propTypes.string,
  tooltip: propTypes.string,
  children: propTypes.oneOfType([propTypes.node, propTypes.element, propTypes.string])
};
InfoBox.defaultProps = {
  theme: 'blue',
  icon: /*#__PURE__*/React.createElement(InfoIcon, null)
};
export default observer(InfoBox);